module.exports = __webpack_public_path__ + "img/header-weddingRingsTwoColors.8b8a147.jpg";